// Interfaces.
import Discussion from "../core/interfaces/Discussion";

// Components to use
import "../components/discussion-search/discussionSearch";
import CCCDiscussionSearch from "../components/discussion-search/discussionSearch";
import { CCCButton } from "../components/forms/button";

// Models.
import CategoryModel from "../models/CategoryModel";
import DiscussionModel from "../models/DiscussionModel";
import { getUrlSearchParam } from "../core/utilities";

export default class IdeasSearchController {
  private $discussionsSearch: CCCDiscussionSearch;
  private slot = `
    <div id="submitSection" style="display: flex; flex-direction: column; align-items: center; margin-top: 10px;">
      <span style="font-weight: bold;">Not what you are looking for?</span>
      <ccc-button id="submitBtn" style="margin-top: 10px;" text="Submit your idea" size="small" type="cta"></ccc-button>
    </div>`;

  constructor(anchor: string) {
    this.$discussionsSearch = <CCCDiscussionSearch>(
      document.querySelector(anchor)
    );
    if (!this.$discussionsSearch) {
      console.error(`Ideas Search - ${anchor} element not found in DOM`);
    }
  }

  /**
   * Initializes the discussion search component.
   * @returns { void }
   */
  public init(): void {
    console.debug("Ideas Search - INIT");
    if (this.$discussionsSearch) {
      try {
        const categoryId = Number(getUrlSearchParam("category_id"));
        if (isNaN(categoryId) || categoryId <= 0) {
          throw "Ideas Search - category_id query parameter doesn't exist or it's invalid";
        } else {
          const sidebar = document.querySelector(".Panel.Panel-main .pageBox");
          if (sidebar) {
            while (sidebar.childElementCount > 0) {
              sidebar.removeChild(sidebar.lastChild);
            }
          }
          this.$discussionsSearch.setAttribute(
            "category-id",
            categoryId.toString()
          );
          this.$discussionsSearch.setAttribute("items-per-page", "10");
          this.$discussionsSearch.onKeywordsValChange(this.removeSlot);
          this.$discussionsSearch.onSearch(this.searchDiscussions);
          this.$discussionsSearch.onDiscussionLoad(this.getDiscussion);
        }
      } catch (error) {
        this.$discussionsSearch.remove();
        throw error;
      }
    }
  }

  /**
   * Removes the slot content from discussion search component.
   */
  private removeSlot = (): void => {
    if (this.$discussionsSearch.firstElementChild) {
      this.$discussionsSearch.firstElementChild.remove();
    }
  };

  /**
   * Searches discussions by keywords.
   * @param { string } keywords
   * @param { number } categoryId
   * @param { number } page
   * @param { number } limit
   * @returns  { Promise<Array<Discussion>> }
   */
  private searchDiscussions = (
    keywords: string,
    categoryId: number,
    page: number,
    limit: number
  ): Promise<Array<Discussion>> => {
    return new Promise((resolve, reject) => {
      DiscussionModel.searchDiscussions(keywords, categoryId, page, limit)
        .then((discussions) => {
          if (discussions.length > 0) {
            this.$discussionsSearch.innerHTML = this.slot;
            const $submitBtn = <CCCButton>(
              this.$discussionsSearch.querySelector("#submitBtn")
            );
            $submitBtn.addEventListener("ccc-button-click", () => {
              CategoryModel.getCategory(categoryId)
                .then((category) => {
                  window.location.href =
                    process.env.VANILLA_COMMUNITY_URL +
                    "post/idea/" +
                    category.urlcode;
                })
                .catch((error) => {
                  console.error(
                    "Ideas Search - Error getting category from API",
                    error
                  );
                });
            });
          }
          resolve(discussions);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  };

  /**
   * Gets discussion by ID.
   * @param { number } discussionId
   * @returns { Promise<Discussion> }
   */
  private getDiscussion = (discussionId: number): Promise<Discussion> => {
    return new Promise((resolve, reject) => {
      DiscussionModel.getDiscussionCached(discussionId)
        .then((discussion) => {
          resolve(discussion);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  };
}
